import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import NavbarMenu from './components/nav';
import 'bootstrap/dist/css/bootstrap.min.css';
import Home from './pages/Home';
import Login from './pages/Login';
import Account from './pages/Account';
import Register from './pages/Register';
import Logout from './pages/Logout';
import Users from './pages/Users';
import Book from './pages/Book';
import Create from './pages/Create';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Footer from './components/footer';
import { HelmetProvider } from 'react-helmet-async';

const root = ReactDOM.createRoot(document.getElementById('root'));

function RootComponent() {
    const [darkMode, setDarkMode] = useState(() => {
        return localStorage.getItem('darkMode') === 'true';
    });

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => setLoading(false), 2000);
        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        localStorage.setItem('darkMode', darkMode);
        if (darkMode) {
            document.body.classList.add('dark-mode');
        } else {
            document.body.classList.remove('dark-mode');
        }
    }, [darkMode]);

    if (loading) {
        return (
            <div className="loading-container d-flex justify-content-center align-items-center vh-100">
                <div className="spinner-border text-success" role="status"></div>
            </div>
        );
    }

    return (
        <HelmetProvider>
            <React.StrictMode>
                <Router>
                    <NavbarMenu darkMode={darkMode} setDarkMode={setDarkMode} />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/account" element={<Account />} />
                        <Route path="/book/:id/:chapter?" element={<Book />} />
                        <Route path="/logout" element={<Logout />} />
                        <Route path="/create" element={<Create />} />
                        <Route path="/users" element={<Users />} />
                    </Routes>
                    <Footer />
                </Router>
            </React.StrictMode>
        </HelmetProvider>
    );
}

root.render(<RootComponent />);

reportWebVitals();
